import { Injectable   } from '@angular/core';
import { Subject      } from 'rxjs/Subject';
import { Observable   } from 'rxjs/Observable';
import {
  IService,
  IOrganist           } from './interfaces';
import { Http         } from '@angular/http';
import { environment  } from '../../environments/environment';
import * as _ from 'lodash';

@Injectable()
export class OrganistService {

  public organists$: Subject<IOrganist[]> = new Subject();

  constructor( private http: Http ) {}

  selectOrganistsAllFetch() {
    return this.organists$.asObservable();
  }

  dispatchOrganistsAllFetch( page: number = 1, pageSize: number = 1000 ): void {
    const url = environment.endPoint + `organists?page=${page}&page_size=${pageSize}`;

    this.http.get( url )
    .subscribe( ( response ) => {
      const payload = <IOrganist[]>response.json();
      this.organists$.next( payload );
    } );
  }
}



// WEBPACK FOOTER //
// ./src/app/providers/organist.service.ts